import type { BoxProgramSlotApiGateway } from "@/modules/boxProgrammation/gateway/boxProgramSlotApiGateway"
import type { BoxProgramSlotDefaultSettingsInputDto } from "@/modules/boxProgrammation/gateway/boxProgramSlotDefaultSettingsDto"
import {
  BoxProgramSlotDefaultSettingsDtoSchema,
  BoxProgramSlotDefaultSettingsInputDtoSchema,
  type BoxProgramSlotDefaultSettingsDto,
} from "@/modules/boxProgrammation/gateway/boxProgramSlotDefaultSettingsDto"
import { LoggerService } from "@modules/common/logger/loggerService"
import type { ApiClient } from "@/modules/core/api/client/apiClient"

export class BoxProgramSlotApi implements BoxProgramSlotApiGateway {
  private programBaseUrl = "/box/programs"

  constructor(private api: ApiClient) {}

  async getBoxProgramSlotDefaultValues(id: string): Promise<BoxProgramSlotDefaultSettingsDto> {
    const resultDto = await this.api.get<BoxProgramSlotDefaultSettingsDto>(
      `${this.programBaseUrl}/${id}/slots/defaultValues`,
    )
    return LoggerService.parseApiDto(BoxProgramSlotDefaultSettingsDtoSchema, resultDto.data)
  }

  async createBoxProgramSlotDefaultValues(
    boxProgramId: string,
    defaultValues: BoxProgramSlotDefaultSettingsInputDto,
  ): Promise<BoxProgramSlotDefaultSettingsDto> {
    const resultDto = await this.api.post<BoxProgramSlotDefaultSettingsDto>(
      `${this.programBaseUrl}/${boxProgramId}/slots/defaultValues`,
      LoggerService.parseApiDto(BoxProgramSlotDefaultSettingsInputDtoSchema, defaultValues),
    )
    return LoggerService.parseApiDto(BoxProgramSlotDefaultSettingsDtoSchema, resultDto.data)
  }

  async updateBoxProgramSlotDefaultValues(
    boxProgramId: string,
    defaultValues: BoxProgramSlotDefaultSettingsInputDto,
  ): Promise<BoxProgramSlotDefaultSettingsDto> {
    const resultDto = await this.api.put<BoxProgramSlotDefaultSettingsDto>(
      `${this.programBaseUrl}/${boxProgramId}/slots/defaultValues`,
      LoggerService.parseApiDto(BoxProgramSlotDefaultSettingsInputDtoSchema, defaultValues),
    )
    return LoggerService.parseApiDto(BoxProgramSlotDefaultSettingsDtoSchema, resultDto.data)
  }
}
